import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, EstadosActivacionInstallOTEnumChoice, EstadosOrdenTrabajoEnumChoice, useTabsFormOnly } from "@/shared";
import { FormTabsOnly, SingleBoxTableTabsOnly, SingleTableBoxScene } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import ActivacionesVisitaPage from "../ActivacionesVisitaPage";

export default function ActivacionesVisitaMainPage() {
    const { handleMethodChange, valueTab } = useTabsFormOnly()
    return <SingleTableBoxScene title="Activaciones - Visita">
        <SingleBoxTableTabsOnly>
            <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
                <Tab label="Pendientes" value={1} {...a11yProps(1)} />
                <Tab label="Pendientes Recoordinadas" value={2} {...a11yProps(2)} />
                <Tab label="Gestionadas" value={3} {...a11yProps(3)} />
                <Tab label="Rechazada" value={4} {...a11yProps(4)} />
            </FormTabsOnly>
        </SingleBoxTableTabsOnly>
        {/* //Pendientes — muestra TODAS las visitas EN ESPERA (con y sin cambio
            de ONT). Antes filtraba requiereCambioOnt=true, por eso las de "No
            requiere cambio" no aparecían aunque tuvieran conceptos por revisar. */}
        <CustomTabPanel value={valueTab} index={1}>
            <ActivacionesVisitaPage
                estadoOT={EstadosOrdenTrabajoEnumChoice.EN_ESPERA}
                estadoActivacion={EstadosActivacionInstallOTEnumChoice.EN_ESPERA}
                enableEdit={true}
            />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
            <ActivacionesVisitaPage
                estadoOT={EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA}
                estadoActivacion={EstadosActivacionInstallOTEnumChoice.EN_ESPERA}
                enableEdit={true}
            />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={3}>
            <ActivacionesVisitaPage
                estadoActivacion={EstadosActivacionInstallOTEnumChoice.GESTIONADA}
                enableEdit={true}
            />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={4}>
            <ActivacionesVisitaPage
                enableEdit={false}
                estadoActivacion={EstadosActivacionInstallOTEnumChoice.RECHAZADA}
                //enableEdit={false}
            />
        </CustomTabPanel>

    </SingleTableBoxScene>
}